<template>
    <v-content>
        <v-layout class="font-weight-bold">
            <v-flex pb-2 class="text-input">
                <v-textarea
                        @input="onChange"
                        @focusout="onFocusOut"
                        @change="onChange"
                        outlined
                        dense
                        solo
                        flat
                        :rows="rows"
                        :placeholder="placeholder"
                        :background-color="backgroundColor"
                        item-color="#3E7662"
                        color="#3E7662"
                        :value="model"
                        type="html"
                        :label="label"
                        :readonly="readonly"
                        :disabled="disabled"
                        :hide-details="hideDetail"
                ></v-textarea>
            </v-flex>
        </v-layout>
    </v-content>
</template>

<script>
    export default {
        name: "TextareaForm",
        props: {
            placeholder: String,
            backgroundColor: {
                type: String,
                default: '#FBF6F3'
            },
            color: String,
            rows: Number,
            label: String,
            model: {
                required: false
            },
            readonly: Boolean,
            disabled: Boolean,
            hideDetail: Boolean,
        },
        methods: {
            onChange(val) {
                this.$emit("update-data", val);
            },
            onFocusOut() {
                this.$emit("focus-out");
            },
        }
    }
</script>

<style scoped>

</style>
